import { TaskStatus } from '@nexelem/graphne-api';

export const SUPPORTED_KANBAN_STATUSES = [TaskStatus.Pending, TaskStatus.InProgress, TaskStatus.Completed];

export type SupportedKanbanStatus = (typeof SUPPORTED_KANBAN_STATUSES)[number];
